import { render, staticRenderFns } from "./ItemProductionFacility.vue?vue&type=template&id=4c8d1ce7"
import script from "./ItemProductionFacility.vue?vue&type=script&lang=js"
export * from "./ItemProductionFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports